import CanalModel from './CanalModel'
import TiposDeCanaisEnum from './TiposDeCanaisEnum'

export default class CanalWhatsAppModel extends CanalModel {
  constructor({
    id = 0,
    nome = '',
    descricao = '',
    providerAPIToken = '',
    providerIdentifier = '',
    providerId = null,
  } = {}) {
    super(id, nome, descricao, TiposDeCanaisEnum.WhatsApp)
    this.providerAPIToken = providerAPIToken
    this.providerIdentifier = providerIdentifier
    this.providerId = providerId
  }
}
